/**
 * Tracks Panel Component
 */

import React, { useEffect, useRef } from "react";
import { usePlaybackStore } from "../store/playbackStore";
import TrackList from "./TrackList";
import TrackLanes from "./TrackLanes";
import "./TracksPanel.css";

const TracksPanel: React.FC = () => {
  const lanesRef = useRef<HTMLDivElement | null>(null);
  const { horizontalScrollPx, setHorizontalScroll } = usePlaybackStore();

  useEffect(() => {
    const node = lanesRef.current;
    if (!node) return;

    if (Math.abs(node.scrollLeft - horizontalScrollPx) > 1) {
      node.scrollLeft = horizontalScrollPx;
    }
  }, [horizontalScrollPx]);

  return (
    <div className="tracks-panel">
      <div className="track-list-column">
        <TrackList />
      </div>
      <div
        ref={lanesRef}
        className="track-lanes-column"
        onScroll={(e) => setHorizontalScroll((e.currentTarget as HTMLDivElement).scrollLeft)}
      >
        <TrackLanes />
      </div>
    </div>
  );
};

export default TracksPanel;
